import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { Tabs } from "antd";
import { findIndex, isEmpty } from "lodash";

@inject("context")
@observer
class WizardForm extends Component {
	static propTypes = {
		service: PropTypes.object.isRequired,
		tabs: PropTypes.array.isRequired,
		onFinish: PropTypes.func.isRequired,
		checkUKTelephone: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		const { tabsService } = props.context;
		const { tabs } = props;
		const { currentFormTab, tabsCount } = tabsService;

		if (isEmpty(currentFormTab)) {
			tabsService.setCurrentFormTab(0);
		}

		if (isEmpty(tabsCount)) {
			tabsService.setTabsCount(tabs.length);
		}
	}

	render() {
		const { service, tabs } = this.props;
		const { tabsService } = this.props.context;
		const { currentFormTab } = tabsService;

		return (
			<Tabs
				activeKey={tabs[currentFormTab].id}
				onTabClick={(key) => {
					let index = findIndex(tabs, ["id", key]);
					tabsService.goToFormTab(index);
				}}
			>
				{tabs.map(({ title, id, content: Cmp }, index) => (
					<Tabs.TabPane
						tab={title}
						key={id}
						disabled={index > tabsService.currentFormTab}
					>
						<Cmp
							form={this.props.form}
							service={service}
							tabs={tabs}
							onFinish={this.props.onFinish}
							checkUKTelephone={this.props.checkUKTelephone}
						/>
					</Tabs.TabPane>
				))}
			</Tabs>
		);
	}
}

export default WizardForm;
